import Client from "../baseClient";
import { Promotion } from "~/entities/promotionEntities";
import { AuthHeaders } from "~/api/endpoints/Auth";

export const PromotionApi = {
  getScheduledPromotions: async (
    authHeaders: AuthHeaders,
    orgId: string,
    siteId: string,
    reqTime: string,
    orderTypeCode: string,
  ) =>
    await Client.post<Promotion[]>(
      `${orgId}/${siteId}/getPromotions`,
      {
        requestedReadyTime: reqTime,
        orderTypeCode: orderTypeCode,
      },
      {
        headers: authHeaders,
      },
    ),
};
